import React from 'react';
import Button from './button';

class PostItem extends React.Component {

	//Fail state for WordPress dashes and hyphens
	renderText(text) {
		return {__html: text };
	}

	renderTags(data) {

		return (
			<ul className="tags-list">
			{data.map((tag, index) =>
				<li className="list__item item--tag" key={index}>
					<a href={tag.url}>{tag.name}</a>
				</li>
			)}				
		</ul>
		)
    }
    
    render() {
        
        const post = this.props.data;

        return(
            <li className="list__item item--post">
                {this.props.full && post.custom_data.featured_image &&
                    <a className="post__cover" href={post.link}>
                        <figure>
                            <img loading="lazy" src={post.custom_data.featured_image.sizes.medium} alt={post.custom_data.featured_image.alt} />
                        </figure>
                    </a>
                }
                <div className="post__meta">
                    {post.tags.length > 0 &&
                        this.renderTags(post.custom_data.tags)
                    }  
                    <h3 className="post__title">
                        <a href={post.link} dangerouslySetInnerHTML={this.renderText(post.title.rendered)} />
                    </h3>
                    {this.props.full &&
                        <React.Fragment>
                            <p className="post__excerpt" dangerouslySetInnerHTML={this.renderText(post.excerpt.rendered)} />
                            <Button cssClass="post__cta button--silent" url={post.link} label={wp_core.i18n.read_more} />
                        </React.Fragment>
                    }                                                    
                </div>						
            </li> 
        )
       
    }

}

export default PostItem;